$(window).load(function(){
$(document).ready(function () {
    setInterval(function () {
        var now = new Date();
        var day = now.getDay();
        var end;
    
        if(day >= 1 && day <= 5) {
            end = new Date(now.getYear(), now.getMonth(), day, 21, 0, 0, 0);    
        } else {
            end = new Date(now.getYear(), now.getMonth(), day, 18, 30, 0, 0);
        }
        
        var timeleft = end.getTime() - now.getTime();
        var diff = new Date(timeleft);
        
    
        $("#timeleft").html("<strong><span style='color: #ce6127;'>Want these items in 2-3 days?</span></strong> Order within <strong><span style='color: #6aa84f;'>" + diff.getHours() + " hrs " + diff.getMinutes() + " Mins </span></strong> and choose Priority shipping at the checkout." );
        
    }, 1000);
});
});